import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';
import terminology from 'javascripts/terminology';

export class GoalName extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['roadmap'];
  }

  static subqueriesForModel(modelClass) {
    // KeyResult has a singular goal, others have goals array
    if (modelClass.typename === 'KeyResult') {
      return { goal: ['name'] };
    }
    return { goals: ['name'] };
  }

  get title() {
    return `${terminology('Goal')} name`;
  }

  exampleContents(): FieldContentsData {
    return { text: `Example ${terminology('goal')}` };
  }

  contentsForRecord(record): FieldContentsData {
    const goal = record.goal || record.goals?.[0];

    if (goal) {
      return {
        text: goal.name,
      };
    }

    return {};
  }
}
